import React from 'react'

const Error404 = () => {
  return (
    <div style={{border: '1px solid red'}}>
      404 Access Denied
    </div>
  )
}

export default Error404
